import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormioControllerService } from "../../../../../services/form-controller/formio-controller.service";
import FormUtils from "../../../../utils/form-utils.component";
import {Store} from "../../../../../services/store.service";
import {DocumentFormControllerService} from "../../../../../services/form-controller/document-form-controller.service";
import {BaseError} from "../../../base-error";
import {ToastrService} from "ngx-toastr";
import { environment } from "../../../../../../environments/environment";
import {BaseForm} from "../../../../../models/base-form";
import Helpers from "../../../../../utils/helpers";

@Component({
  selector: "document-form",
  templateUrl: "./document.component.html",
  styleUrls: ["./document.component.css"],
  providers: [DocumentFormControllerService, FormioControllerService],
})

export class DocumentFormComponent extends BaseError implements OnInit {

  public serviceId: string;
  @Input() public determinantMapById: { [key: string]: string };
  @Input() public documentForm: BaseForm = new BaseForm();
  @Input() public focusCompKey?: string;
  @Output() public formReverted: EventEmitter<BaseForm> = new EventEmitter();
  public activeTab: string = "form";
  public formLoaded: boolean = false;
  public showHistory: boolean = false;

  constructor(private route: ActivatedRoute,
              public store: Store,
              public toastr: ToastrService,
              public documentFormController: DocumentFormControllerService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.store.state.common.applicantFormPage.set("document-form");
    });
  }

  public saveTutorial(e) {
    if (e) {
      this.documentForm.tutorials.general = e;
      this.saveForm(this.documentForm.formSchema);
    }
  }

  public saveForm(formSchema: any) {
    if (this.documentForm.id) {
      // add version to distinguish old and new form builder components
      if (formSchema && formSchema.components) {
        for (const comp of formSchema.components) {
          FormUtils.updateWithVersion(comp);
          FormUtils.updateTableAttributes(comp);
          FormUtils.completeColumnsRows(comp);
        }
      }
    }
    this.documentForm.formSchema = formSchema;
    if (this.documentForm.id) {
      this.documentFormController.saveDocumentForm(this.documentForm).subscribe(
          () => undefined,
          (error) => this.showErrorMessage(error),
      );
    } else {
      this.documentFormController.createDocumentForm(this.serviceId, this.documentForm).subscribe(
        (data) => {
          this.documentForm = (data ? data : this.documentForm);
        },
      );
    }
  }

  public notifyTabChange(newtab: string): void {
    this.activeTab = newtab;
  }

  public openHistory() {
    this.showHistory = true;
  }

  public closeHistory() {
    this.showHistory = false;
  }

  public changeForm(revisionNumber: string): void {
    if (revisionNumber) {
      // Step 1: GET the schema for validation
      this.documentFormController.getFormSchemaForRevision(this.serviceId, revisionNumber).subscribe((schema) => {
        if (schema) {
          // Step 2: Validate schema for duplicate keys
          const result = Helpers.validateFormSchema(schema);
          if (Array.isArray(result) && result.length > 0) {
            this.error("Please reload page!\n" + Helpers.generateValidationErrorMessages(result).join("\n"), 'Validation error');
          }
          else {
            // Step 3: If valid, call PUT to revert (triggers cleanup of orphaned relations)
            this.documentFormController.revertFormToRevision(this.serviceId, revisionNumber).subscribe(
              () => {
                // Step 4: Reload the form after successful reversion
                this.documentFormController.getDocumentForm(this.serviceId, false).subscribe(
                  (data) => {
                    this.documentForm = data ? data : this.documentForm;
                    this.formReverted.emit(this.documentForm);
                    this.responseSuccessful("Form reverted successfully");
                  },
                  (error) => this.showErrorMessage(error)
                );
              },
              (error) => this.showErrorMessage(error)
            );
          }
        }
      });
    }
  }
}
